<div class="card">
    <app-header titulo="Baixa de insumo" descricao="Dados das baixas de insumos"></app-header>

    <p-table [value]="consumiveis"  [(selection)]="consumiveisSelecionados" dataKey="idConsum" #dt [loading]="loading" [globalFilterFields]="['moduloOrigem','instancia','noBoletim','noSequencia','cdMaterialPims','dtMovimento','noOs','cdCcustoPims','fgTpMovim','cdEmpresaErp','cdFilialErp','cdMaterialErp','qtConsumo','cdUnidadeErp','cdCcustoErp','cdDepositoErp','noDocErp','fgRevertido','fgStatusInteg','dtIntegPims','dtIntegErp','deMensagemInteg']" styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines text-sm" [rowsPerPageOptions]="[20, 50, 100, 500, 1000]" [paginator]="true" [rows]="20" [showCurrentPageReport]="true" currentPageReportTemplate="{{consumiveisSelecionados.length}} Registros selecionados | Mostrando de {first} até {last} de {totalRecords} registros" [scrollable]="true" scrollHeight="40.5rem" [resizableColumns]="true" >
        <ng-template pTemplate="caption">

              

            <div class="flex">
                <app-empresa-dropdown [(selecionadas)]="instanciaSelecionada" />
                <!-- <p-multiSelect
                 appendTo="body"
                 [options]="instancias"
                 [filter]="true"
                 [style]="{'width':'200px'}"
                 optionValue="id"
                 optionLabel="nome"
                 [(ngModel)]="instanciaSelecionada"
                 dataKey="id" inputId="id"
                 placeholder="Instância"
                 emptyMessage="Nenhuma instância"
                 (onChange)="getConsumiveis()"> 
                
                </p-multiSelect>-->
                <p-calendar
                class="ml-3 text-sm"
                  [(ngModel)]="rangeDates"
                  selectionMode="range"
                  dateFormat="dd/mm/yy"
                  [readonlyInput]="true" 
                  (onClose)="getConsumiveis()"/>
                
                  <button pButton pRipple icon="pi pi-file-excel" class="ml-3 text-sm" (click)="exportar()" label="Exportar"></button>

                  <button *ngIf="tentativasHabilitado" pButton pRipple icon="pi pi-send" class="ml-3 text-sm" (click)="reenviar()" label="Reenviar"></button>

                
                <span class="p-input-icon-left ml-auto">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($any($event.target)?.value, 'contains')" placeholder="Pesquisar" />
                </span>
                <button pButton pRipple icon="pi pi-refresh" class="ml-3" (click)="getConsumiveis()"></button>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr class="text-sm text-500">
                <th style="width: 4rem"><p-tableHeaderCheckbox /></th>
                <th>Instância</th>
                <th>Boletim</th>
                <th>Sequência</th>
                <th>Material PIMS</th>
                <th>Data Movimento</th>
                <th>OS</th>
                <th>Centro Custo (PIMS)</th>
                <th>Movimento</th>
                <th>Empresa (ERP)</th>
                <th>Filial (ERP)</th>
                <th>Material (ERP)</th>
                <th>Quantidade Consumo</th>
                <th>Unidade (ERP)</th>
                <th>Centro Custo (ERP)</th>
                <th>Depósito (ERP)</th>
                <th class="nowrap">No DOC (ERP)</th>
                <th>Revertido</th>
                <th pSortableColumn="fgStatusInteg" class="nowrap">
                    Status
                    <p-sortIcon field="fgStatusInteg" />
                    <p-columnFilter field="fgStatusInteg" matchMode="in" display="menu" [showApplyButton]="false"
                                    [showClearButton]="false" [showMatchModes]="false" [showOperator]="false"
                                    [showAddButton]="false">
                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                            <p-multiSelect [ngModel]="value" selectedItemsLabel="Vários selecionados" [options]="status"
                                           placeholder="Todos" [filter]="true" optionValue="value" (onChange)="filter($event.value)"
                                           optionLabel="name">
                                <ng-template let-option pTemplate="item">
                                    <div class="inline-block vertical-align-middle">
                                        <span class="ml-1 mt-1">{{ option.name }}</span>
                                    </div>
                                </ng-template>
                            </p-multiSelect>
                        </ng-template>
                        <ng-template pTemplate="clearfiltericon">
                        </ng-template>
                    </p-columnFilter>
                </th>
                <th>Data Envio PIMS</th>
                <th>Data Integrado</th>
                <th pSortableColumn="deMensagemInteg" class="nowrap">Mensagem <p-sortIcon field="deMensagemInteg" /></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-consumivel>
            <tr class="text-sm text-500">
                <td><p-tableCheckbox [value]="consumivel" /></td>
                <td>{{ consumivel.instancia }}</td>
                <td>{{ consumivel.noBoletim }}</td>
                <td>{{ consumivel.noSequencia }}</td>
                <td>{{ consumivel.cdMaterialPims }}</td>
                <td>{{ consumivel.dtMovimento | date: 'dd/MM/yyyy' }}</td>
                <td>{{ consumivel.noOs }}</td>
                <td>{{ consumivel.cdCcustoPims }}</td>
                <td>{{ consumivel.fgTpMovim }}</td>
                <td>{{ consumivel.cdEmpresaErp }}</td>
                <td>{{ consumivel.cdFilialErp }}</td>
                <td>{{ consumivel.cdMaterialErp }}</td>
                <td>{{ consumivel.qtConsumo.toLocaleString("pt-BR", { minimumFractionDigits: 3, maximumFractionDigits: 3})  || 0 }}</td>
                <td>{{ consumivel.cdUnidadeErp }}</td>
                <td>{{ consumivel.cdCcustoErp }}</td>
                <td>{{ consumivel.cdDepositoErp }}</td>
                <td  class="nowrap">{{ consumivel.noDocErp }}</td>
                <td>{{ consumivel.fgRevertido }}</td>
                <td  class="nowrap"><app-tag-status [status]="consumivel.fgStatusInteg" ></app-tag-status></td>
                <td>{{ consumivel.dtIntegPims | date: 'dd/MM/yyyy' }}</td>
                <td>{{ consumivel.dtIntegErp | date: 'dd/MM/yyyy' }}</td>
                <td class="nowrap">{{ consumivel.deMensagemInteg }}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <td colspan="21">Nenhum registro encontrado e/ou selecione os filtros</td>
        </ng-template>
    </p-table>
</div>